module.exports = __webpack_public_path__ + "img/hyundai-New.4742548b.png";